/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = () => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: 'What types of enterprise clients do you work with?',
            answer: 'We work with government agencies, large enterprises, and mid-size organizations across various industries including healthcare, finance, and technology. Our solutions are designed to meet the unique needs of mission-critical systems.',
        },
        {
            question: 'How do you ensure data security and compliance?',
            answer: 'We implement industry-leading security practices including end-to-end encryption, comprehensive data governance, automated backups, and disaster recovery. Our solutions are designed to meet GDPR, HIPAA, and FedRAMP requirements.',
        },
        {
            question: 'What is your typical project timeline?',
            answer: 'Project timelines vary based on scope and complexity. We follow an agile methodology with regular milestones and deliverables. Most enterprise projects range from 3-12 months, with ongoing support and maintenance available.',
        },
        {
            question: 'Do you provide ongoing support and maintenance?',
            answer: 'Yes, we offer comprehensive support and maintenance services including 24/7 monitoring, regular updates, security patches, and technical support. We provide SLAs to ensure your systems remain operational and secure.',
        },
        {
            question: 'What cloud platforms do you work with?',
            answer: 'We have expertise in AWS, Azure, and Google Cloud Platform. We can help with cloud migration, architecture design, and ongoing cloud management. Our solutions support multi-region deployments for high availability.',
        },
        {
            question: 'How do you handle project communication and reporting?',
            answer: 'We maintain transparent communication through regular status updates, sprint reviews, and stakeholder meetings. You will have access to project dashboards and detailed reports on progress, milestones, and metrics.',
        },
    ];

    return (
        <Box>
            <Box 
                marginBottom={5} 
                textAlign="center"
                sx={{
                    position: 'relative',
                }}
            >
                <Typography
                    data-aos="fade-up"
                    sx={{
                        textTransform: 'uppercase',
                        fontWeight: 700,
                        letterSpacing: '0.15em',
                        fontSize: '0.875rem',
                        color: theme.palette.primary.main,
                        marginBottom: 2,
                    }}
                >
                    Frequently Asked Questions
                </Typography>
                <Box
                    component={Typography}
                    fontWeight={900}
                    variant={'h2'}
                    gutterBottom
                    data-aos="fade-up"
                    data-aos-delay="100"
                    sx={{
                        fontSize: { xs: '2.5rem', md: '3.5rem' },
                        lineHeight: 1.1,
                        letterSpacing: '-0.02em',
                        position: 'relative',
                        display: 'inline-block',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: '-15px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '60px',
                            height: '4px',
                            background: theme.palette.primary.main,
                            borderRadius: '2px',
                        },
                    }}
                >
                    Common Questions About Our Services
                </Box>
                <Typography
                    variant={'h6'}
                    component={'p'}
                    color={'textSecondary'}
                    sx={{
                        maxWidth: '700px',
                        margin: '0 auto',
                        lineHeight: 1.7,
                    }}
                >
                    Find answers to common questions about our enterprise technology solutions and services.
                </Typography>
            </Box>
            <Box maxWidth={900} margin="0 auto">
                {faqs.map((faq, index) => (
                    <Accordion
                        key={index}
                        expanded={expanded === `panel${index}`}
                        onChange={handleChange(`panel${index}`)}
                        sx={{
                            marginBottom: 2,
                            boxShadow: 2,
                            borderRadius: 2,
                            '&:before': {
                                display: 'none',
                            },
                            '&.Mui-expanded': {
                                marginBottom: 2,
                            },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                paddingX: 3,
                                paddingY: 2,
                                '& .MuiAccordionSummary-content': {
                                    margin: 0,
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                fontWeight={600}
                                sx={{
                                    fontSize: { xs: '1rem', md: '1.1rem' },
                                }}
                            >
                                {faq.question}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                paddingX: 3,
                                paddingBottom: 3,
                            }}
                        >
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ lineHeight: 1.7 }}
                            >
                                {faq.answer}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Box>
    );
};

export default FAQ;

